export const enumKeys = <O extends Record<string, any>, K extends keyof O = keyof O>(obj: O): K[] =>
    Object.keys(obj).filter((k) => Number.isNaN(+k)) as K[]
